import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const NorthDakota = () => {
  return (
    <StatePropertyTaxPage
      stateName="North Dakota"
      processDescription="Property owners may appeal their assessment by filing with the local board of equalization within 25 days of receiving notice. Appeals should include evidence supporting the property owner's claimed value."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in April, allowing property owners time to review their assessments before the appeal deadline."
      valuationAsOfDate="February 1"
      valuationAsOfDateExplanation="North Dakota assesses property as of February 1 each year. This winter assessment date captures property values during the quieter real estate season."
      deadlineExplanation="Property owners have 25 days from receiving the assessment notice to file appeals with the local board of equalization. This typically results in a May deadline."
    />
  );
};

export default NorthDakota;